export const planos = [
  { value: 'Bronze' },
  { value: 'Prata' },
  { value: 'Ouro' },
  { value: 'Platina' },
  { value: 'Personalizado' }
];
